























































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Inairequipment from "../../../store/entities/inairequipment";
@Component
export default class EditInairequipments extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  inairequipment: Inairequipment = new Inairequipment();
  updateInt:number=0;
  updateG:number=0;
  displaynone = "";
  updateIntervals=false;
  gflist=[];
  seltime=[
    {value: 1,label: '1分钟'},
    {value: 5,label: '5分钟'},
    {value: 10,label: '10分钟'},
    {value: 15,label: '15分钟'},
    {value: 30,label: '30分钟'},
    {value: 60,label: '60分钟'},
    {value: 120,label: '120分钟'},
    {value: 240,label: '240分钟'},
    {value: 360,label: '360分钟'},
    {value: 720,label: '720分钟'},
    {value: 1440,label: '1440分钟'},
  ]
  seltypelist=[];
  save() {
    (this.$refs.inairequipmentForm as any).validate(async (valid: boolean) => {
      if (valid) {
        if(this.updateIntervals==true){
          this.inairequipment.updateInterval=1;
        }else{
          this.inairequipment.updateInterval=0;
        }
          
        await this.$store.dispatch({
          type: "inairequipment/update",
          data: this.inairequipment,
        });
        (this.$refs.inairequipmentForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  get warehouse() {
    return this.$store.state.warehouse.filterlist;
  }
  get factory() {
    return this.$store.state.factory.list;
  }
   get floor() {
    return this.$store.state.floor.filterlist;
  }
  get gwequipment() {
    return this.$store.state.gwequipment.list;
  }
  get inairthreshold(){
     return this.$store.state.inairthreshold.list;
  }
  selfactory(value:Number){
    this.inairequipment.ftId = value;
    this.getwarehouse();
      this.getfloor();
  }
  selwarehouse(value:Number){
    this.inairequipment.wId = value;
    this.getfloor();
  }
  selfloor(value:Number){
    this.inairequipment.fId = value;
  }
  seltype(value:Number){
this.inairequipment.gId = value;
  }
  selEth(){
    this.displaynone="display:none";

  }
  selth(){
    this.displaynone = "";
  }
  
  async getwarehouse() {
    //库房
    //filters
    await this.$store.dispatch({
      type: "warehouse/getfilter",
      data: this.inairequipment,
    });
  }
  async getfloor() {
    //楼层
    //filters
    await this.$store.dispatch({
      type: "floor/getfilter",
      data: this.inairequipment,
    });
  }
  cancel() {
    (this.$refs.inairequipmentForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.inairequipment = Util.extend(true, {}, this.$store.state.inairequipment.editInairequipment);
     
      if(this.inairequipment.updateInterval==0){
        this.inairequipment.updateInterval=false;
      }else{
        this.inairequipment.updateInterval=true;
      }
      this.selfactory(this.inairequipment.ftId);
      this.selwarehouse(this.inairequipment.wId);
      this.selfloor(this.inairequipment.fId);
    }
  }
   inairequipmentRule = {
     ftId: [{type:"number",required: true, message: "请选择库区", trigger: "change" }],
    wId: [{type:"number",required: true, message: "请选择库房", trigger: "change" }],
    snid: [{ required: true, message: "请填写SN号", trigger: "blur" }],
    fId: [{type:"number",required: true, message: "请选择楼层", trigger: "change" }],
    locationName: [{ required: true, message: "请填写位置", trigger: "blur" }],
    // number: [{transform: (value) => String(value), required: true, message: "请填写位置编号", trigger: "blur" }],
    //gId:[{ type:"number",required: true, message: "请选择阈值方案", trigger: "change" }],
    inair_type:[{ type:"number",required: true, message: "请选择气体类型", trigger: "change" }],
    acquisitionInterval: [{type:'number',required: true, message: "请选择采集间隔", trigger: "change" }],
    // gId:[{type:"number",required:true,message:"请选择网关",trigger:"change"}]
  };
}
